import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { heroQuotes } from '../data/offer';
export function HeroQuotes() {
  return <section className="w-full border-b border-line bg-sand" aria-label="What dog owners say" data-id="element-157" data-mp="a1z7qqj21u3f">
      <ul className="mx-auto grid max-w-6xl gap-px bg-line lg:grid-cols-3" data-id="element-158" data-mp="euse1iu69ahm">
        {heroQuotes.map(quote => <li key={quote.name} className="flex flex-col bg-sand px-5 py-7 sm:px-8 sm:py-8" data-id="element-159" data-mp="ixot4zki6ogt">
            <QuoteIcon className="h-5 w-5 shrink-0 text-terracotta/60" aria-hidden="true" data-id="element-160" data-mp="3n9ir6q9zur1v" />
            <blockquote className="mt-4 flex-1 font-display text-base leading-snug text-ink sm:text-lg" data-id="element-161" data-mp="3ram8lh7owv57">
              “{quote.quote}”
            </blockquote>
            <p className="mt-6 text-xs font-bold uppercase tracking-[0.14em] text-terracotta" data-id="element-162" data-mp="16lezqsjgb1xm">
              {quote.name}
            </p>
            <p className="mt-1 text-xs text-muted" data-id="element-163" data-mp="1biyd7q8braoi">{quote.role}</p>
          </li>)}
      </ul>
    </section>;
}